import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import ManualAffiliateAdd from './ManualAffiliateAdd';

const ManualAffiliateAddLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    competitorResearch: false,
    messages: false,
    support: false,
    settings: false
  });
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentUser] = useState({ name: '', email: '', plan: '', avatar: '', initials: '' });

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({ ...prev, [menuKey]: !prev[menuKey] }));
  };

  return (
    <div className="min-h-screen transition-all duration-300 bg-gray-50 dark:bg-slate-950 text-sm">
      <Sidebar sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} openMenus={openMenus} toggleMenu={toggleMenu} />
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        <Header sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} searchQuery={searchQuery} setSearchQuery={setSearchQuery} notifications={notifications} setNotifications={setNotifications} showNotifications={showNotifications} setShowNotifications={setShowNotifications} showProfileDropdown={showProfileDropdown} setShowProfileDropdown={setShowProfileDropdown} currentUser={currentUser} />
        <ManualAffiliateAdd />
      </div>
    </div>
  );
};

export default ManualAffiliateAddLayout;
